import { App } from '@default/app';
import { ErrorBoundary } from '@libs/core';
import { getGlobalVariables } from '@libs/hooks';
import { fetchScenario, getInitPlayerOptions, store } from '@libs/store';
import { Loading } from '@libs/utils';
import { ClearSessionPage } from '../pages/ClearSessionPage';
import { DeepLinkPage } from '../pages/DeepLinkPage';

export async function rootLoader() {
    if (navigator?.onLine) {
        store.dispatch(
            fetchScenario({
                action: undefined,
                widgetUid: undefined,
                isShowLoader: true,
                initPayerOptions: getInitPlayerOptions(),
            }),
        );
    }
}

const { deepLinkPath } = getGlobalVariables('deepLinkPath');

const arrayOfDeepLinks = (deepLinkPath ?? '')
    .trim()
    .split(',')
    .map((path) => path.trim())
    .filter((path) => path.length > 0);

const router = [
    {
        path: '/',
        element: <App />,
        errorElement: <ErrorBoundary />,
        hydrateFallbackElement: <Loading />,
        loader: rootLoader,
        shouldRevalidate: () => false,
    },
    {
        path: '/clearSession',
        element: <ClearSessionPage />,
        errorElement: <ErrorBoundary />,
        hydrateFallbackElement: <Loading />,
    },
];
arrayOfDeepLinks.forEach((path) =>
    router.push({
        path: `${path}/*`,
        element: <DeepLinkPage />,
        errorElement: <ErrorBoundary />,
        hydrateFallbackElement: <Loading />,
    }),
);
router.push({
    path: '*',
    element: <>Not found</>,
    errorElement: <ErrorBoundary />,
    hydrateFallbackElement: <Loading />,
});

export default router;
